import React, { useContext } from 'react'
import './style/Q3.css'
import Headling from '../Headling'
import Subtitle from '../Subtitle'
import YesOrNoQuestion from '../YesOrNoQuestion'
import { setNewAnswer } from '../../Store'
import { useHistory } from 'react-router-dom'
import StepCounter from '../StepCounter'
import gif11 from './assets/08_shield 2.gif'
import jpg11 from './assets/static/08_shield-2.jpg'

import '../Gif.css'
import ReactPixel from 'react-facebook-pixel';
import { AppContext} from '../../contexts/AppProvider'
import { useLocalize } from 'localize-react';

function Q11() {
    const { settings } = useContext(AppContext)
    const history = useHistory();
    const { translate } = useLocalize()
    
    return (
        <>
            <div className="picHold hid vis">
                <img className="gif11" src={settings.isAnimationPause ? jpg11 : gif11} />
            </div>
            <Headling text={translate('Satisfaction Guaranteed')} />
            <Subtitle text={translate('Did my landlord require a bank guarantee?')} />
            <YesOrNoQuestion onYesClick={() => {
                setNewAnswer({
                    11: 1,
                }
                )
                history.push('/Q/12')
                ReactPixel.trackCustom('bail_yes', '');
            }}
                onNoClick={() => {
                    setNewAnswer({
                        11: 0,

                    })
                    history.push('/Q/12')
                    ReactPixel.trackCustom('bail_no', '');
                }} />
            <StepCounter />
        </>
    )
}



export default Q11

